import * as React from 'react'
import * as ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { createStore, applyMiddleware, compose } from 'redux'
import reduxThunk from 'redux-thunk'
import logger from 'redux-logger'

import { AppContainer } from './AppContainer'
import registerServiceWorker from './registerServiceWorker'
import './index.scss'
import './styles/BootstrapOverride.scss'
import './styles/Navbar.scss'
import './styles/Card.scss'
import './styles/Sidebar.scss'
import './styles/ListGroup.scss'
import './styles/Button.scss'
import './styles/Label.scss'
import './styles/DropdownMenu.scss'
import { loadReportGroupList } from './pages/ReportsList/actions/LoadReportGroupList'
import { loadMarketList } from './pages/ReportGroupSelection/actions/LoadMarketList'
import { BrowserRouter } from 'react-router-dom'
import { createRootReducer } from './reducers/root-reducer'
import { MonitoringService } from './common/MonitoringService'
import { MessageService } from './common/MessageService'
import { configuration } from './rest-api/Configuration'

import 'regenerator-runtime/runtime'
import { getMsalInstance } from './auth/authProvider'

const composeEnhancers =
  (window['__REDUX_DEVTOOLS_EXTENSION_COMPOSE__'] as typeof compose) || compose

const messageService = new MessageService(
  configuration.WelcomeMessages.Storage,
  configuration.WelcomeMessages.Session
);

const store = createStore(createRootReducer(messageService), composeEnhancers(applyMiddleware(reduxThunk, logger)))

getMsalInstance().then(() => {
  ReactDOM.render(
    <Provider store={store}>
      <BrowserRouter>
        <AppContainer
          monitoringService={new MonitoringService()}
          messageService={messageService}
        />
      </BrowserRouter>
    </Provider>
    ,
    document.getElementById('root') as HTMLElement
  )
  registerServiceWorker()
  store.dispatch(loadReportGroupList() as any)
  store.dispatch(loadMarketList() as any)
})
